import React from "react";
import Container from "components/Layout/Container";
import { Steps, useStepper } from "../../components/Ui/Stepper";
import { useStore } from "_Store";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ConseillerBasicForm from "./components/forms/ConseillerBasicForm";

import PersonalInformation from "./components/forms/PersonalInformation";
import ContactInformation from "./components/forms/ContactInformation";
import SelectProducts from "./components/forms/SelectProducts";
import Identifiers from "./components/forms/Identifiers";
import AddFarm from "./components/AddFarm";
import StepCompleted from "./components/StepCompleted";
import { Typography } from "@mui/material";
import { signup } from "services/auth.service";
import ConseillerContact from "./components/forms/ConseillerContact";
import { func } from "helpers";
import Structure from "./components/forms/Structure";
import StructureOwner from "./components/forms/StructureOwner";
import { notification } from "antd";

const register = {
  PRESTATAIRE: {
    steps: [
      {
        label: "Informations personnelles",
        element: Structure,
      },
      {
        label: "Informations de Contact",
        element: StructureOwner,
      },
      {
        label: "Créez un mot de passe",
        element: Identifiers,
      },
    ],
  },
  CONSEILLER: {
    steps: [
      {
        label: "Informations personnelles",
        element: ConseillerBasicForm,
      },
      {
        label: "Informations de Contact",
        element: ConseillerContact,
      },
      {
        label: "Créez un mot de passe",
        element: Identifiers,
      },
    ],
  },
};
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SignupAdmin = () => {
  const { setUtils } = useStore();
  const [open, setOpen] = React.useState(false);
  const [alertMsg, setMessage] = React.useState("");
  const location = useLocation();
  const navigate = useNavigate();

  let accountType;

  try {
    accountType = location.state.accountType.toUpperCase();
  } catch (error) {
    window.location.pathname = "/";
  }
  const steps = register[accountType].steps;
  const { activeStep: step, handleNext, handleBack } = useStepper();
  const [formData, setFormData] = React.useState([]);
  const [allStepsCompleted, setCompleted] = React.useState(
    step === steps.length
  );

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const isLastStep = step === register[accountType].steps.length - 1;

  const handleAddFormData = async (data) => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        ...data,
      }));
    }

    if (!isLastStep) {
      handleNext();
    } else {
      const payload = {
        ...formData,
        password: data.password,
        // isAuth: true,
        accountType,
      };
      console.log(payload);
      try {
        const response = await signup(payload);
        console.log(response);
        if (response.data.success) {
          notification.success({
            message: `Compte ${accountType} crée ! \n Veuillez attendre la validation`,
          });
          console.log("success \n", response.data);

          setTimeout(() => navigate("/"), 3000);
        } else {
          // setMessage("Hey there notification");
          // handleClick();
          notification.error({
            message: response.data.message
          })

          setUtils("loading", { spinning: false, primary: "" });
        }
      } catch (err) {
        if (err.response) {
          setMessage(err.response.data.message);
          handleClick();
        }
        setUtils("loading", { spinning: false, primary: "" });
      }
    }
  };

  const stepContainer = (WrapperComponent) => {
    return (
      <WrapperComponent
        onSubmit={(pl) => handleAddFormData(pl)}
        onBack={handleBack}
        data={formData}
      />
    );
  };

  return (
    <Container>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        style={{ top: "85px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {alertMsg}
        </Alert>
      </Snackbar>

      <div className="sm:w-1/4 bg-white">
        <div className="flex flex-col h-full justify-center py-10 sm:py-0">
          {
            <div className="pl-4 sm:pl-12">
              <div className="py-4">
                <Typography>
                  Etape {step + 1} sur {register[accountType].steps.length}
                </Typography>
              </div>
              <Steps steps={register[accountType].steps} />
            </div>
          }
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        <div className="w-full max-w-[800px]">
          {stepContainer(register[accountType].steps[step].element)}
        </div>
      </div>
    </Container>
  );
};

export default SignupAdmin;
